import * as React from "react"
import styled from "styled-components"
import Button from "./themableUI/button"

import Input, { TextArea } from "./themableUI/input"

import { getObjectStyles } from "./themableUI/utilities/themify"

const StyledContactForm = styled.div`
  ${props =>
    props.theme.contactForm
      ? getObjectStyles(props.theme.contactForm.styles)
      : ""};
`

const StyledForm = styled.form`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  ${props =>
    props.theme.contactForm && props.theme.contactForm.form
      ? getObjectStyles(props.theme.contactForm.form.styles)
      : ""};
`

const ContactForm = () => {
  return (
    <StyledContactForm>
      <StyledForm
        name="xooldra-contact-form"
        method="POST"
        data-netlify="true"
        netlify-honeypot="bot-field"
      >
        <input type="hidden" name="bot-field" />
        <input type="hidden" name="form-name" value="xooldra-contact-form" />
        <Input name="visitorName" id="visitorName" type="text">
          name
        </Input>
        <Input name="visitorEmail" id="visitorEmail" type="email">
          email address
        </Input>

        <TextArea name="message" id="message">
          message
        </TextArea>
        <Button type="submit">Send</Button>
      </StyledForm>
    </StyledContactForm>
  )
}

export default ContactForm
